import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export default function ChapterHeader({ number, title, subtitle, dark = false }) {
  const { t } = useLang();
  return (
    <div className="mb-14 sm:mb-20">
      <motion.p
        data-testid={`chapter-${number}-label`}
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className={`mb-5 font-mono-alt text-xs uppercase tracking-[0.35em] ${dark ? "text-ivory/50" : "text-bordeaux/70"}`}
      >
        {t.chapter} {number}
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 26 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        className={`max-w-3xl font-display text-4xl font-medium leading-[1.04] tracking-tight sm:text-5xl lg:text-6xl ${
          dark ? "text-ivory" : "text-ink"
        }`}
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.18 }}
          className={`mt-5 max-w-xl text-base leading-relaxed sm:text-lg ${dark ? "text-ivory/60" : "text-stone-500"}`}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
